module.exports = __webpack_public_path__ + "static/media/flooring_gwp_60yd_n.9964ba14.csv";